export default __webpack_public_path__ + "static/media/seurakunta.39fac15f.jpg";